module.exports = __webpack_public_path__ + "img/8ad4087d58914925a5aaba2d522c746c-1024.64237cbd.jpg";